module.exports = __webpack_public_path__ + "img/sad.ab368ca6.png";